import { Platform } from '@angular/cdk/platform';
import { DatePipe } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { NotificationService } from '../services/notification/notification.service';
import { CustomDateAdapter } from './adapters/custom-date-adapter/customDateAdapter';
import { CustomMatPaginatorIntl } from './configuration/MatPaginatorConfiguration';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
    declarations: [],
    imports: [
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
    ],
    providers: [
        DatePipe,
        NotificationService,
        {
            provide: MatPaginatorIntl,
            useClass: CustomMatPaginatorIntl,
        },
        { provide: MAT_DATE_LOCALE, useValue: 'nl-NL' },
        { provide: LOCALE_ID, useValue: 'nl-NL' },
        { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE, Platform] },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class CoreModule {}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
